import { V2EnergyConservationEnergySavingPiePostResponse } from '@maxtropy/dmes-apis-v2';
import React, { FC, useMemo } from 'react';
import { getPieChartOption } from './charts';
import { Spin } from 'antd';
import styles from './index.module.scss';
import { useTheme, EchartsWithTheme } from '@maxtropy/components';

interface IEnergySavingPie {
  energySavingData?: V2EnergyConservationEnergySavingPiePostResponse;
  loading?: boolean;
}

const EnergySavingPie: FC<IEnergySavingPie> = props => {
  const { energySavingData, loading } = props;
  const theme = useTheme();

  // 饼图图表
  const chartPieOption = useMemo(() => getPieChartOption(energySavingData), [energySavingData]);

  return (
    <div className={styles.chart_box}>
      {loading ? (
        <Spin spinning={true} className={styles.spin_box} />
      ) : (
        <EchartsWithTheme style={{ height: 240, minWidth: 480 }} type="pie" option={chartPieOption} theme={theme} />
      )}
    </div>
  );
};

export default EnergySavingPie;
